export default __webpack_public_path__ + "static/media/preview-image(2).d692c5c0.png";